import * as XLSX from 'xlsx';

// Standard DYL contact fields offered as mapping targets (Import Data loads the full list from mapping_fields)
export const STANDARD_IMPORT_FIELDS = [
    { key: 'first_name', value: 'first_name', text: 'First Name' },
    { key: 'last_name', value: 'last_name', text: 'Last Name' },
    { key: 'full_name', value: 'full_name', text: 'Full Name (split into first and last)' },
    { key: 'email', value: 'email', text: 'Email' },
    { key: 'phone', value: 'phone', text: 'Phone' },
    { key: 'mobile_phone', value: 'mobile_phone', text: 'Mobile Phone' },
    { key: 'company', value: 'company', text: 'Company / Account Name' },
    { key: 'job_title', value: 'job_title', text: 'Job Title' },
    { key: 'street', value: 'street', text: 'Street Address' },
    { key: 'city', value: 'city', text: 'City' },
    { key: 'state', value: 'state', text: 'State' },
    { key: 'zip', value: 'zip', text: 'Zip Code' },
    { key: 'source', value: 'source', text: 'Lead Source' },
    { key: 'notes', value: 'notes', text: 'Notes' }
];

export const NAME_FIELDS = ['first_name', 'last_name', 'full_name'];
export const CONTACT_METHOD_FIELDS = ['email', 'phone', 'mobile_phone'];

// Same values as the Import Data module selector
export const IMPORT_MODULE_OPTIONS = [
    { key: 'contacts', value: 'Contact', text: 'Contacts' },
    { key: 'leads', value: 'Lead', text: 'Leads' },
    { key: 'opportunity', value: 'Opportunity', text: 'Opportunities' },
    { key: 'customer', value: 'Customer', text: 'Customers' }
];

export const CONFIDENCE_LABELS = {
    high: { text: 'High', color: 'green' },
    medium: { text: 'Check', color: 'yellow' },
    none: { text: 'No match', color: 'grey' }
};

export const EMAIL_PROVIDER_OPTIONS = [
    { key: 'google', value: 'google', text: 'Gmail / Google Workspace' },
    { key: 'outlook', value: 'outlook', text: 'Outlook / Microsoft 365' },
    { key: 'other', value: 'other', text: 'Something else, or not now' }
];

export const ACCEPTED_IMPORT_TYPES = '.csv,.xlsx,.xls';
export const MAX_IMPORT_FILE_SIZE = 10 * 1024 * 1024;
// Enough rows to find duplicates quickly in the browser; the full file is checked again at import
export const MAX_ANALYZED_ROWS = 5000;

// Reads the first sheet the same way Import Data does
export const readSpreadsheet = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        try {
            const workbook = XLSX.read(reader.result, { type: 'array' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const [headerRow = [], ...rows] = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false, defval: '' });
            resolve({ headers: headerRow.map((header, index) => String(header).trim() || `Column ${index + 1}`), rows });
        } catch (e) {
            reject(e);
        }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
});
